export default __webpack_public_path__ + "static/media/power.346f46a8.svg";